import { render, staticRenderFns } from "./NetflowConfigModal.vue?vue&type=template&id=67c00f84&"
import script from "./NetflowConfigModal.vue?vue&type=script&lang=js&"
export * from "./NetflowConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports